import { App } from "../components/App";

export default function Hexfill(): JSX.Element {
  return <App />;
}
